import React, { useEffect } from 'react'
import Bredcom from '../../Bredcom/Main'
import Header from '../../headerone/Main'
import Blog from '../../menhome/Blog'
import Newlast from '../../menhome/Newlast'
import Equality from '../mengenderequality/Equality'


function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Gender equality";
  }, [])

  return (
    <>
        <Header/>

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Home"
            title="gender equality"
            subtitledown="Gender Equality"
           />
            <Equality/>
            <Blog/>
            <Newlast/>
        </div>
    </>
  )
}

export default Main